export const createCookie = (key, value) => {
   document.cookie = `${key}=${value}; path=/; domain=${window.location.hostname}`
}

export const getCookie = (key) => {
    let name = key + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
   return "";
}

export function eraseCookie(key) {
  const current = process.env.REACT_APP_ENV
  if(current === 'dev') {
    document.cookie = key + `=; expires=Thu, 01 Jan 1970 00:00:00 UTC`
  } else {
    document.cookie = key + `=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`
  }
}


// WEBPACK FOOTER //
// ./src/util/use-cookie.js